<panel width="420">
  @for (responsibleType of responsibleTypes; track responsibleType) {
	<h1>{{ 'company.responsible-type.' + companyResponsibleTypeEnum[responsibleType] | translate }}</h1>
	<section>
	  <icon type="circle-user" [userIcon]="responsibleUser(responsibleType)" />
	  @if (editResponsible && editResponsible != undefined) {
		<custom-select [selectList]="userList" [autoSort]="true" [value]="responsibleUser(responsibleType)?.id" (valueChange)="updateCompanyResponsible(responsibleType, $event)" [placeholder]="'company.no-responsible' | translate: { 'responsible.type': (('company.responsible-type.' + companyResponsibleTypeEnum[responsibleType]) | translate) }" />
	  }
	  @if (!editResponsible && editResponsible != undefined) {
		<div [ngClass]="{ 'out-of-focus' : !responsibleUser(responsibleType) }" style="padding: 5px;">{{ responsibleUser(responsibleType) ? responsibleUser(responsibleType)?.name : ('company.no-responsible' | translate: { 'responsible.type': 'company.responsible-type.' + companyResponsibleTypeEnum[responsibleType] | translate }) }}</div>
	  }
	  @if (responsibleUser(responsibleType)?.email) {
		<a [href]="sanitizer.bypassSecurityTrustUrl('callto:' + responsibleUser(responsibleType)?.email)">{{ 'general.call-user' | translate }}</a>
	  }
	</section>
  }
</panel>
